import gql from 'graphql-tag';

const GET_SUBJECT_PROGRESS = gql`
  query GetSubjectProgress($subject: String!) {
    userProgress(subject: $subject)
  }
`;

export default GET_SUBJECT_PROGRESS;
